class FreeShippingProgress extends HTMLElement {
  static get observedAttributes() {
    return ['current', 'country'];
  }

  rules = {
    GB: { goal: 70, currency: '£', label: 'FREE SHIPPING' },
    CA: { goal: 215, currency: '$', label: 'FREE SHIPPING' },
    AU: { goal: 120, currency: '$', label: 'FREE SHIPPING' },
    DE: { goal: 65, currency: '€', label: 'FREE SHIPPING' },
    US: { goal: 100, currency: '$', label: 'FREE SHIPPING' }
  };

  connectedCallback() {
    this.current = Number(this.getAttribute('current')) || 0;
    this.country = (this.getAttribute('country') || 'US').toUpperCase();
    this.render();
    requestAnimationFrame(() => this.update());
  }

  attributeChangedCallback() {
    this.current = Number(this.getAttribute('current')) || 0;
    this.country = (this.getAttribute('country') || 'US').toUpperCase();
    this.update();
  }

  render() {
    this.innerHTML = `
      <div class="text"></div>
      <div class="bar">
        <div class="fill"></div>
      </div>
    `;
    this.textEl = this.querySelector('.text');
    this.fillEl = this.querySelector('.fill');
  }

  update() {
    const rule = this.rules[this.country];

    // 🚫 Do not show anything for REST / unsupported countries
    if (!rule) {
        this.style.display = 'none';
        return;
    }

    const remaining = Math.max(rule.goal - this.current, 0);
    const percent = Math.min((this.current / rule.goal) * 100, 100);

    if (remaining === 0) {
      this.textEl.textContent = `🎉 ${rule.label} UNLOCKED`;
    } else {
      this.textEl.textContent =
        `🚚 You’re only ${rule.currency}${remaining.toFixed(2)} away from ${rule.label.toLowerCase()}!`;
    }

    requestAnimationFrame(() => {
      this.fillEl.style.width = `${percent}%`;
    });
  }
}

if (!customElements.get('free-shipping-progress')) {
  customElements.define('free-shipping-progress', FreeShippingProgress);
}